import type { ContourProps } from './contour-definitions';
import type { PointArray } from './types/contour-definition-array-type';

import { ContourType } from './contour-definitions';
import { LineContour } from './line-contour';

export class AnnotationArrowContour extends LineContour {
  constructor(
    props: Partial<ContourProps> & Pick<ContourProps, 'type' | 'label'>,
    pointArray: PointArray,
  ) {
    super(props, pointArray);

    if (props.type !== ContourType.AnnotationArrowContour) {
      throw new Error('AnnotationArrowContour - Invalid contour type');
    }
  }
}
